export function mapSurveyLocalization(
  countryCode: string,
  languageShortCode: string,
): string {
  return `${languageShortCode}_${countryCode}`;
}
